import { useState } from 'react'

import { PDFDocumentProxy } from 'pdfjs-dist'
import { Document, Page, pdfjs } from 'react-pdf'
import ResizeDetector from 'react-resize-detector'

import { Stack } from '@collaborate-health/uikit'

import ContentSkeleton from './ArticleContentSkeleton'

pdfjs.GlobalWorkerOptions.workerSrc = '/static/js/pdf.worker.min.mjs'

const MAX_WIDTH = 1024

export interface PdfContentProps {
  url: string
}

const ArticlePdfContent: React.FC<PdfContentProps> = ({ url }) => {
  const [width, setWidth] = useState(MAX_WIDTH)
  const [document, setDocument] = useState<PDFDocumentProxy | null>(null)

  return (
    <>
      <Stack direction='row' justifyContent='center' overflow='auto'>
        <Document loading={<ContentSkeleton width={width} />} file={url} onLoadSuccess={setDocument}>
          {document &&
            Array.from(new Array(document.numPages), (_, index) => (
              <Page
                key={`page_${index + 1}`}
                loading={<ContentSkeleton width={width} />}
                pageNumber={index + 1}
                width={Math.min(width, MAX_WIDTH)}
              />
            ))}
        </Document>
      </Stack>
      <ResizeDetector handleWidth onResize={(newWidth, _) => setWidth(newWidth ?? 0)} />
    </>
  )
}

export default ArticlePdfContent

